(function () {
const root = document.getElementById('twk-homepage');
if (!root) return;

/* ===== V9.77.4 BEST SELLERS: PRODUCT LINKS + REAL AJAX ADD TO CART ===== */
const twkBestVariantCache = new Map();

function twkBestProductJsonUrl(productUrl) {
  try {
    const url = new URL(productUrl, window.location.origin);
    const match = url.pathname.match(/\/products\/[^/?#]+/i);
    if (!match) return '';
    return match[0].replace(/\/$/, '') + '.js';
  } catch (error) {
    return '';
  }
}

async function twkBestResolveVariantId(productUrl) {
  const endpoint = twkBestProductJsonUrl(productUrl);
  if (!endpoint) {
    throw new Error('Best Seller product URL must be a /products/... link.');
  }
  if (twkBestVariantCache.has(endpoint)) {
    return twkBestVariantCache.get(endpoint);
  }
  const response = await fetch(endpoint, {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
  });
  if (!response.ok) {
    throw new Error('Unable to load product data.');
  }
  const product = await response.json();
  const variants = Array.isArray(product.variants) ? product.variants : [];
  const variant = variants.find(function (item) { return item.available; });
  if (!variant || !variant.id) {
    throw new Error('This product is sold out.');
  }
  twkBestVariantCache.set(endpoint, Number(variant.id));
  return Number(variant.id);
}

/* Homepage Best Sellers color/metal swatches — mirrors collection-card selection behavior. */
root.addEventListener('click', function (event) {
  const swatch = event.target && event.target.closest ? event.target.closest('[data-twk-home-card-swatch]') : null;
  if (!swatch || swatch.disabled || !root.contains(swatch)) return;

  const card = swatch.closest('.twk-product-card');
  if (!card) return;
  const addButton = card.querySelector('[data-twk-best-add]');
  if (!addButton || addButton.disabled) return;

  addButton.dataset.variantId = swatch.dataset.variantId || '';

  card.querySelectorAll('[data-twk-home-card-swatch]').forEach(function (item) {
    const selected = item === swatch;
    item.classList.toggle('is-active', selected);
    item.setAttribute('aria-pressed', selected ? 'true' : 'false');
  });

  const price = card.querySelector('.twk-product-card__price');
  if (price && swatch.dataset.variantPrice) {
    price.textContent = swatch.dataset.variantPrice;
  }

  if (swatch.dataset.variantImage) {
    const image = card.querySelector('.twk-product-card__media img');
    if (image) image.src = swatch.dataset.variantImage;
  }
});

root.querySelectorAll('[data-twk-best-add]').forEach(function (button) {
  button.addEventListener('click', async function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) return;

    const productUrl = (button.dataset.productUrl || '').trim();
    const configuredVariantId = Number((button.dataset.variantId || '').trim()) || 0;
    const originalText = 'Add To Cart';
    button.disabled = true;
    button.classList.remove('is-added');
    button.textContent = 'Adding…';

    try {
      const variantId = configuredVariantId || await twkBestResolveVariantId(productUrl);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer-section',
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        let message = 'Unable to add this item.';
        try {
          const errorData = await response.json();
          if (errorData && errorData.description) message = errorData.description;
        } catch (ignore) {}
        throw new Error(message);
      }

      const result = await response.json();
      button.classList.add('is-added');
      button.textContent = '✓ Added';

      root.dispatchEvent(new CustomEvent('twk:cart:added', {
        detail: result,
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('twk:cart:added', {
        detail: result
      }));

      window.setTimeout(function () {
        button.classList.remove('is-added');
        button.textContent = originalText;
        button.disabled = false;
      }, 1600);
    } catch (error) {
      console.warn('[TEWIKY Best Sellers]', error);
      button.textContent = error && /sold out/i.test(error.message || '') ? 'Sold Out' : 'Check Product Link';
      window.setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
      }, 1800);
    }
  });
});
/* ===== /V9.77.4 BEST SELLERS ===== */
const heroCarousel = root.querySelector('[data-twk-hero-carousel]');
if (heroCarousel) {
const slides = Array.from(heroCarousel.querySelectorAll('[data-twk-hero-slide]'));
const dots = Array.from(heroCarousel.querySelectorAll('[data-twk-hero-dot]'));
const prev = heroCarousel.querySelector('[data-twk-hero-prev]');
const next = heroCarousel.querySelector('[data-twk-hero-next]');
let index = 0;
let timer = 0;
let pausedByPointer = false;
let pausedByFocus = false;
let heroIsVisible = true;
let touchX = 0;
let touchY = 0;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function stop() {
if (timer) window.clearTimeout(timer);
timer = 0;
}
function canAutoplay() {
return slides.length > 1 && heroIsVisible && !document.hidden &&
!pausedByPointer && !pausedByFocus && !reduceMotion.matches;
}
function schedule() {
stop();
if (!canAutoplay()) return;
timer = window.setTimeout(function () {
go(index + 1, false);
schedule();
}, 5600);
}
function go(target, userAction) {
if (!slides.length) return;
const safe = (target + slides.length) % slides.length;
slides.forEach(function (slide, i) {
const active = i === safe;
slide.classList.toggle('is-active', active);
slide.setAttribute('aria-hidden', active ? 'false' : 'true');
});
dots.forEach(function (dot, i) {
const active = i === safe;
dot.classList.toggle('is-active', active);
if (active) dot.setAttribute('aria-current', 'true');
else dot.removeAttribute('aria-current');
});
index = safe;
if (userAction) schedule();
}
if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
if (next) next.addEventListener('click', function () { go(index + 1, true); });
dots.forEach(function (dot, i) {
dot.addEventListener('click', function () { go(i, true); });
});
heroCarousel.addEventListener('mouseenter', function () { pausedByPointer = true; stop(); });
heroCarousel.addEventListener('mouseleave', function () { pausedByPointer = false; schedule(); });
heroCarousel.addEventListener('focusin', function () { pausedByFocus = true; stop(); });
heroCarousel.addEventListener('focusout', function (event) {
if (!heroCarousel.contains(event.relatedTarget)) { pausedByFocus = false; schedule(); }
});
heroCarousel.addEventListener('touchstart', function (event) {
if (!event.touches || !event.touches[0]) return;
touchX = event.touches[0].clientX;
touchY = event.touches[0].clientY;
}, { passive: true });
heroCarousel.addEventListener('touchend', function (event) {
if (!event.changedTouches || !event.changedTouches[0]) return;
const dx = event.changedTouches[0].clientX - touchX;
const dy = event.changedTouches[0].clientY - touchY;
if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.25) {
go(index + (dx < 0 ? 1 : -1), true);
}
}, { passive: true });
document.addEventListener('visibilitychange', function () {
if (document.hidden) stop(); else schedule();
});
if ('IntersectionObserver' in window) {
const observer = new IntersectionObserver(function (entries) {
heroIsVisible = !!entries[0] && entries[0].isIntersecting;
if (heroIsVisible) schedule(); else stop();
}, { threshold: 0.12 });
observer.observe(heroCarousel);
}
if (typeof reduceMotion.addEventListener === 'function') {
reduceMotion.addEventListener('change', schedule);
}
go(0, false);
schedule();
}
const heroProofs = Array.from(root.querySelectorAll('[data-twk-hero-proof]'));
const heroProofMotionMQ = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
function setupHeroProof(heroProof) {
let raf = 0;
let px = 0;
let py = 0;
function reset() {
if (raf) window.cancelAnimationFrame(raf);
raf = 0;
heroProof.classList.remove('is-pointer-active');
heroProof.style.setProperty('--twk-proof-rx', '0deg');
heroProof.style.setProperty('--twk-proof-ry', '0deg');
heroProof.style.setProperty('--twk-proof-tx', '0px');
heroProof.style.setProperty('--twk-proof-ty', '0px');
heroProof.style.setProperty('--twk-proof-glow-x', '50%');
heroProof.style.setProperty('--twk-proof-glow-y', '50%');
}
function render() {
raf = 0;
if (!heroProofMotionMQ.matches) return;
const rect = heroProof.getBoundingClientRect();
if (!rect.width || !rect.height) return;
const x = Math.max(0, Math.min(rect.width, px - rect.left));
const y = Math.max(0, Math.min(rect.height, py - rect.top));
const nx = (x / rect.width) * 2 - 1;
const ny = (y / rect.height) * 2 - 1;
heroProof.style.setProperty('--twk-proof-rx', (ny * -3.2).toFixed(2) + 'deg');
heroProof.style.setProperty('--twk-proof-ry', (nx * 4.2).toFixed(2) + 'deg');
heroProof.style.setProperty('--twk-proof-tx', (nx * 2.8).toFixed(2) + 'px');
heroProof.style.setProperty('--twk-proof-ty', (ny * 2.1).toFixed(2) + 'px');
heroProof.style.setProperty('--twk-proof-glow-x', ((x / rect.width) * 100).toFixed(1) + '%');
heroProof.style.setProperty('--twk-proof-glow-y', ((y / rect.height) * 100).toFixed(1) + '%');
}
heroProof.addEventListener('pointerenter', function (event) {
if (!heroProofMotionMQ.matches) return;
px = event.clientX; py = event.clientY;
heroProof.classList.add('is-pointer-active');
if (!raf) raf = window.requestAnimationFrame(render);
});
heroProof.addEventListener('pointermove', function (event) {
if (!heroProofMotionMQ.matches) return;
px = event.clientX; py = event.clientY;
if (!raf) raf = window.requestAnimationFrame(render);
});
heroProof.addEventListener('pointerleave', reset);
if (typeof heroProofMotionMQ.addEventListener === 'function') {
heroProofMotionMQ.addEventListener('change', function () {
if (!heroProofMotionMQ.matches) reset();
});
}
}
heroProofs.forEach(setupHeroProof);
const reviewTrack = root.querySelector('[data-twk-review-track]');
const reviewPrev = root.querySelector('[data-twk-review-prev]');
const reviewNext = root.querySelector('[data-twk-review-next]');
const reviewDots = Array.from(root.querySelectorAll('[data-twk-review-dot]'));
function twkReviewMetrics() {
if (!reviewTrack) return { cardStep: 0, pageStep: 0, desktopPageStep: 0 };
const card = reviewTrack.querySelector('.twk-review-card');
if (!card) return { cardStep: 0, pageStep: 0, desktopPageStep: 0 };
const styles = window.getComputedStyle(reviewTrack);
const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
const cardStep = card.getBoundingClientRect().width + gap;
const pageStep = cardStep * (window.innerWidth <= 749 ? 1 : 3);
return {
cardStep: cardStep,
pageStep: pageStep,
desktopPageStep: cardStep * 3
};
}
function twkReviewPageIndex() {
if (!reviewTrack) return 0;
const m = twkReviewMetrics();
if (!m.desktopPageStep) return 0;
const index = Math.round(reviewTrack.scrollLeft / m.desktopPageStep);
return Math.max(0, Math.min(2, index));
}
function twkUpdateReviewUI() {
if (!reviewTrack) return;
const maxScroll = Math.max(
0,
reviewTrack.scrollWidth - reviewTrack.clientWidth
);
if (reviewPrev) reviewPrev.disabled = reviewTrack.scrollLeft <= 4;
if (reviewNext) reviewNext.disabled = reviewTrack.scrollLeft >= maxScroll - 4;
const activePage = twkReviewPageIndex();
reviewDots.forEach(function (dot, index) {
dot.classList.toggle('is-active', index === activePage);
});
}
if (reviewTrack) {
if (reviewPrev) {
reviewPrev.addEventListener('click', function () {
reviewTrack.scrollBy({
left: -twkReviewMetrics().pageStep,
behavior: 'smooth'
});
});
}
if (reviewNext) {
reviewNext.addEventListener('click', function () {
reviewTrack.scrollBy({
left: twkReviewMetrics().pageStep,
behavior: 'smooth'
});
});
}
reviewDots.forEach(function (dot) {
dot.addEventListener('click', function () {
const page = Number(dot.getAttribute('data-twk-review-dot')) || 0;
const target = twkReviewMetrics().desktopPageStep * page;
reviewTrack.scrollTo({
left: target,
behavior: 'smooth'
});
});
});
reviewTrack.addEventListener('scroll', function () {
window.requestAnimationFrame(twkUpdateReviewUI);
});
window.addEventListener('resize', twkUpdateReviewUI);
twkUpdateReviewUI();
}
const tiktokTrack = root.querySelector('[data-twk-tiktok-track]');
const tiktokPrev = root.querySelector('[data-twk-tiktok-prev]');
const tiktokNext = root.querySelector('[data-twk-tiktok-next]');
function twkTiktokStep() {
if (!tiktokTrack) return 0;
const card = tiktokTrack.querySelector('.twk-tiktok-card');
if (!card) return 0;
const styles = window.getComputedStyle(tiktokTrack);
const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
const cardsPerClick = window.innerWidth <= 749 ? 1 : 6;
return (card.getBoundingClientRect().width + gap) * cardsPerClick;
}
function twkUpdateTiktokArrows() {
if (!tiktokTrack || !tiktokPrev || !tiktokNext) return;
const maxScroll = Math.max(
0,
tiktokTrack.scrollWidth - tiktokTrack.clientWidth
);
tiktokPrev.disabled = tiktokTrack.scrollLeft <= 4;
tiktokNext.disabled = tiktokTrack.scrollLeft >= maxScroll - 4;
}
if (tiktokTrack && tiktokPrev && tiktokNext) {
tiktokPrev.addEventListener('click', function () {
tiktokTrack.scrollBy({
left: -twkTiktokStep(),
behavior: 'smooth'
});
});
tiktokNext.addEventListener('click', function () {
tiktokTrack.scrollBy({
left: twkTiktokStep(),
behavior: 'smooth'
});
});
tiktokTrack.addEventListener('scroll', function () {
window.requestAnimationFrame(twkUpdateTiktokArrows);
});
window.addEventListener('resize', twkUpdateTiktokArrows);
twkUpdateTiktokArrows();
}
const tiktokCards = Array.from(root.querySelectorAll('[data-twk-tiktok-card]'));
const tiktokPlayerOrigin = 'https://www.tiktok.com';
function twkEnsureTiktokNetworkHints() {
if (!document.querySelector('link[data-twk-tiktok-preconnect]')) {
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = tiktokPlayerOrigin;
preconnect.crossOrigin = 'anonymous';
preconnect.setAttribute('data-twk-tiktok-preconnect', '');
document.head.appendChild(preconnect);
}
if (!document.querySelector('link[data-twk-tiktok-dns]')) {
const dns = document.createElement('link');
dns.rel = 'dns-prefetch';
dns.href = '//www.tiktok.com';
dns.setAttribute('data-twk-tiktok-dns', '');
document.head.appendChild(dns);
}
}
twkEnsureTiktokNetworkHints();
function twkBuildTiktokPlayerSrc(postId) {
if (!postId) return '';
return tiktokPlayerOrigin + '/player/v1/' + postId
+ '?autoplay=0'
+ '&controls=1'
+ '&progress_bar=1'
+ '&play_button=1'
+ '&volume_control=1'
+ '&fullscreen_button=1'
+ '&timestamp=0'
+ '&loop=0'
+ '&music_info=0'
+ '&description=0'
+ '&rel=0'
+ '&native_context_menu=0';
}
function twkTiktokMessage(iframe, type, value) {
if (!iframe || !iframe.contentWindow) return;
iframe.contentWindow.postMessage(
{
type: type,
value: value,
'x-tiktok-player': true
},
'*'
);
}
function twkCreateTiktokPlayer(card) {
if (!card || card.dataset.twkPlayerCreated === '1') return;
const embed = card.querySelector('[data-twk-tiktok-embed]');
const postId = (card.getAttribute('data-twk-tiktok-id') || '').trim();
if (!embed || !postId) return;
card.dataset.twkPlayerCreated = '1';
const iframe = document.createElement('iframe');
iframe.src = twkBuildTiktokPlayerSrc(postId);
iframe.loading = 'eager';
iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
iframe.setAttribute('allowfullscreen', 'allowfullscreen');
iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
iframe.setAttribute('data-twk-tiktok-iframe', postId);
iframe.title = 'TikTok post ' + postId;
iframe.addEventListener('load', function () {
card.dataset.twkIframeLoaded = '1';
card.classList.add('is-preview-ready');
if (card.dataset.twkPendingPlay === '1') {
card.dataset.twkPendingPlay = '0';
card.classList.add('is-playing');
window.setTimeout(function () {
twkTiktokMessage(iframe, 'play');
}, 45);
}
});
embed.innerHTML = '';
embed.appendChild(iframe);
}
function twkPauseTiktokCard(card) {
if (!card) return;
const iframe = card.querySelector('[data-twk-tiktok-iframe]');
if (iframe) {
twkTiktokMessage(iframe, 'pause');
}
card.classList.remove('is-playing');
card.dataset.twkPendingPlay = '0';
card.dataset.twkPlayerState = 'paused';
}
function twkPauseOtherTiktokCards(activeCard) {
tiktokCards.forEach(function (card) {
if (card === activeCard) return;
twkPauseTiktokCard(card);
});
}
function twkPlayTiktokCard(card) {
if (!card) return;
twkPauseOtherTiktokCards(card);
twkCreateTiktokPlayer(card);
const iframe = card.querySelector('[data-twk-tiktok-iframe]');
card.classList.add('is-playing');
card.dataset.twkPendingPlay = '1';
if (iframe) {
twkTiktokMessage(iframe, 'play');
window.setTimeout(function () {
if (card.classList.contains('is-playing')) {
twkTiktokMessage(iframe, 'play');
}
}, 110);
}
}
window.addEventListener('message', function (event) {
const data = event.data;
if (
!data ||
data['x-tiktok-player'] !== true ||
typeof data.type !== 'string'
) {
return;
}
let matchedCard = null;
let matchedIframe = null;
for (let i = 0; i < tiktokCards.length; i += 1) {
const iframe = tiktokCards[i].querySelector('[data-twk-tiktok-iframe]');
if (iframe && iframe.contentWindow === event.source) {
matchedCard = tiktokCards[i];
matchedIframe = iframe;
break;
}
}
if (!matchedCard || !matchedIframe) return;
if (data.type === 'onPlayerReady') {
matchedCard.dataset.twkPlayerReady = '1';
matchedCard.classList.add('is-preview-ready');
if (matchedCard.dataset.twkPendingPlay === '1') {
matchedCard.dataset.twkPendingPlay = '0';
matchedCard.classList.add('is-playing');
twkTiktokMessage(matchedIframe, 'play');
}
}
if (data.type === 'onStateChange') {
matchedCard.dataset.twkPlayerState = String(data.value);
if (Number(data.value) === 1) {
matchedCard.dataset.twkPendingPlay = '0';
matchedCard.classList.add('is-playing');
}
}
if (data.type === 'onPlayerError') {
matchedCard.dataset.twkPlayerError = '1';
matchedCard.classList.add('is-preview-ready');
}
});
tiktokCards.forEach(function (card) {
const media = card.querySelector('.twk-tiktok-media');
const playBtn = card.querySelector('[data-twk-tiktok-play]');
if (playBtn) {
playBtn.addEventListener('click', function (event) {
event.preventDefault();
event.stopPropagation();
twkPlayTiktokCard(card);
});
}
if (media) {
media.addEventListener('click', function (event) {
if (event.target.closest('[data-twk-tiktok-play]')) return;
if (event.target.closest('iframe')) return;
if (
!card.classList.contains('is-preview-ready') &&
!card.classList.contains('is-playing')
) {
twkPlayTiktokCard(card);
}
});
}
card.addEventListener(
'pointerenter',
function () {
twkCreateTiktokPlayer(card);
},
{ passive: true }
);
card.addEventListener(
'pointerdown',
function () {
twkCreateTiktokPlayer(card);
},
{ passive: true }
);
card.addEventListener('focusin', function () {
twkCreateTiktokPlayer(card);
});
});
if ('IntersectionObserver' in window && tiktokTrack) {
const tiktokWarmObserver = new IntersectionObserver(
function (entries, observer) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
tiktokCards.forEach(function (card, index) {
window.setTimeout(function () {
twkCreateTiktokPlayer(card);
}, index * 42);
});
observer.disconnect();
});
},
{
root: null,
rootMargin: '1400px 0px',
threshold: 0.001
}
);
tiktokWarmObserver.observe(tiktokTrack);
} else {
window.setTimeout(function () {
tiktokCards.forEach(function (card, index) {
window.setTimeout(function () {
twkCreateTiktokPlayer(card);
}, index * 48);
});
}, 450);
}
document.addEventListener('visibilitychange', function () {
if (document.hidden) {
tiktokCards.forEach(function (card) {
twkPauseTiktokCard(card);
});
}
});
const communityTrack = root.querySelector('[data-twk-community-track]');
const communityPrev = root.querySelector('[data-twk-community-prev]');
const communityNext = root.querySelector('[data-twk-community-next]');
function twkCommunityStep() {
if (!communityTrack) return 0;
const card = communityTrack.querySelector('.twk-insta-post');
if (!card) return 0;
const styles = window.getComputedStyle(communityTrack);
const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
const cardsPerClick = window.innerWidth <= 749 ? 1 : 6;
return (card.getBoundingClientRect().width + gap) * cardsPerClick;
}
function twkUpdateCommunityArrows() {
if (!communityTrack || !communityPrev || !communityNext) return;
const maxScroll = Math.max(
0,
communityTrack.scrollWidth - communityTrack.clientWidth
);
communityPrev.disabled = communityTrack.scrollLeft <= 4;
communityNext.disabled = communityTrack.scrollLeft >= maxScroll - 4;
}
if (communityTrack && communityPrev && communityNext) {
communityPrev.addEventListener('click', function () {
communityTrack.scrollBy({
left: -twkCommunityStep(),
behavior: 'smooth'
});
});
communityNext.addEventListener('click', function () {
communityTrack.scrollBy({
left: twkCommunityStep(),
behavior: 'smooth'
});
});
communityTrack.addEventListener('scroll', function () {
window.requestAnimationFrame(twkUpdateCommunityArrows);
});
window.addEventListener('resize', twkUpdateCommunityArrows);
twkUpdateCommunityArrows();
}
const liveTriggers = Array.from(root.querySelectorAll('[data-twk-live-trigger]'));
const liveCards = Array.from(root.querySelectorAll('[data-twk-live-card]'));
function closeAllLiveCards(exceptCard = null) {
liveCards.forEach(function(card) {
if (exceptCard && card === exceptCard) return;
card.classList.remove('is-open');
card.setAttribute('aria-hidden', 'true');
const buyBtn = card.querySelector('[data-twk-live-card-buy]');
if (buyBtn && !buyBtn.classList.contains('is-added')) {
buyBtn.textContent = 'Shop';
buyBtn.disabled = false;
}
});
liveTriggers.forEach(function(trigger) {
const card = trigger.closest('.twk-insta-media')?.querySelector('[data-twk-live-card]');
const expanded = !!(card && card.classList.contains('is-open'));
trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
});
}
liveTriggers.forEach(function(trigger) {
trigger.addEventListener('click', function(event) {
event.preventDefault();
event.stopPropagation();
const media = trigger.closest('.twk-insta-media');
const card = media ? media.querySelector('[data-twk-live-card]') : null;
if (!card) return;
const isOpen = card.classList.contains('is-open');
closeAllLiveCards();
if (!isOpen) {
card.classList.add('is-open');
card.setAttribute('aria-hidden', 'false');
trigger.setAttribute('aria-expanded', 'true');
} else {
trigger.setAttribute('aria-expanded', 'false');
}
});
});
liveCards.forEach(function(card) {
const buyBtn = card.querySelector('[data-twk-live-card-buy]');
const variantId = (card.dataset.productVariant || '').trim();
if (buyBtn) {
buyBtn.addEventListener('click', async function(event) {
event.preventDefault();
event.stopPropagation();
buyBtn.disabled = true;
buyBtn.textContent = 'Adding…';
if (!variantId) {
window.setTimeout(function () {
buyBtn.classList.add('is-added');
buyBtn.textContent = '✓ Added';
buyBtn.disabled = false;
}, 320);
return;
}
try {
const response = await fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'Accept': 'application/json'
},
body: JSON.stringify({
items: [{
id: Number(variantId),
quantity: 1
}],
sections: 'cart-drawer-section',
sections_url: window.location.pathname
})
});
if (!response.ok) {
throw new Error('Unable to add this item.');
}
const result = await response.json();
buyBtn.classList.add('is-added');
buyBtn.textContent = '✓ Added';
buyBtn.disabled = false;
root.dispatchEvent(new CustomEvent('twk:cart:added', {
detail: result
}));
} catch (error) {
buyBtn.disabled = false;
buyBtn.textContent = 'Try again';
}
});
}
});
document.addEventListener('click', function(event) {
if (event.target.closest('[data-twk-live-card]')) return;
if (event.target.closest('[data-twk-live-trigger]')) return;
closeAllLiveCards();
});
document.addEventListener('keydown', function(event) {
if (event.key === 'Escape') {
closeAllLiveCards();
}
});
root.querySelectorAll('[data-twk-like], [data-twk-save]').forEach(function (btn) {
btn.addEventListener('click', function () {
btn.classList.toggle('is-active');
});
});
const mobileTouchMQ = window.matchMedia(
'(max-width: 749px) and (pointer: coarse)'
);
const mobileTouchSelectors = [
'.twk-hero__social-proof',
'.twk-trust__item',
'.twk-category',
'.twk-product-card',
'.twk-promo-card',
'.twk-birthstone',
'.twk-why-item',
'.twk-trending-card',
'.twk-editorial__copy',
'.twk-review-card',
'.twk-insta-post',
'.twk-tiktok-card',
'.twk-bottom-service'
];
const mobileTouchTargets = Array.from(
root.querySelectorAll(mobileTouchSelectors.join(','))
);
const mobileTouchState = new WeakMap();
function twkClamp(value, min, max) {
return Math.max(min, Math.min(max, value));
}
function twkResetMobileTouch(el, immediate) {
const state = mobileTouchState.get(el);
if (state && state.raf) {
window.cancelAnimationFrame(state.raf);
state.raf = 0;
}
el.classList.remove('is-touching', 'is-touch-dragging');
const clearVars = function () {
el.style.setProperty('--twk-touch-x', '0px');
el.style.setProperty('--twk-touch-y', '0px');
el.style.setProperty('--twk-touch-px', '0px');
el.style.setProperty('--twk-touch-py', '0px');
el.style.setProperty('--twk-touch-tilt', '0deg');
};
if (immediate) {
clearVars();
} else {
window.setTimeout(clearVars, 170);
}
}
function twkRenderMobileTouch(el) {
const state = mobileTouchState.get(el);
if (!state || !state.active) return;
state.raf = 0;
const dx = state.x - state.startX;
const dy = state.y - state.startY;
const distance = Math.hypot(dx, dy);
if (distance > 7) {
state.dragged = true;
el.classList.add('is-touch-dragging');
}
const tx = twkClamp(dx * .025, -2.2, 2.2);
const ty = twkClamp(dy * .018, -1.7, 1.7);
const px = twkClamp(dx * .10, -5.5, 5.5);
const py = twkClamp(dy * .055, -3.2, 3.2);
const tilt = twkClamp(dx * .045, -2.2, 2.2);
el.style.setProperty('--twk-touch-x', tx.toFixed(2) + 'px');
el.style.setProperty('--twk-touch-y', ty.toFixed(2) + 'px');
el.style.setProperty('--twk-touch-px', px.toFixed(2) + 'px');
el.style.setProperty('--twk-touch-py', py.toFixed(2) + 'px');
el.style.setProperty('--twk-touch-tilt', tilt.toFixed(2) + 'deg');
}
function twkActivateMobileTouchTargets() {
mobileTouchTargets.forEach(function (el) {
el.classList.add('twk-touch-target');
el.addEventListener('pointerdown', function (event) {
if (!mobileTouchMQ.matches || event.pointerType === 'mouse') return;
const state = {
active: true,
dragged: false,
startX: event.clientX,
startY: event.clientY,
x: event.clientX,
y: event.clientY,
raf: 0
};
mobileTouchState.set(el, state);
el.classList.add('is-touching');
el.style.setProperty('--twk-touch-x', '0px');
el.style.setProperty('--twk-touch-y', '0px');
el.style.setProperty('--twk-touch-px', '0px');
el.style.setProperty('--twk-touch-py', '0px');
el.style.setProperty('--twk-touch-tilt', '0deg');
}, { passive: true });
el.addEventListener('pointermove', function (event) {
if (!mobileTouchMQ.matches || event.pointerType === 'mouse') return;
const state = mobileTouchState.get(el);
if (!state || !state.active) return;
state.x = event.clientX;
state.y = event.clientY;
if (!state.raf) {
state.raf = window.requestAnimationFrame(function () {
twkRenderMobileTouch(el);
});
}
}, { passive: true });
function endTouch() {
const state = mobileTouchState.get(el);
if (state) state.active = false;
twkResetMobileTouch(el, false);
}
el.addEventListener('pointerup', endTouch, { passive: true });
el.addEventListener('pointercancel', endTouch, { passive: true });
el.addEventListener('lostpointercapture', endTouch, { passive: true });
});
}
if (mobileTouchTargets.length) {
twkActivateMobileTouchTargets();
if (typeof mobileTouchMQ.addEventListener === 'function') {
mobileTouchMQ.addEventListener('change', function () {
if (!mobileTouchMQ.matches) {
mobileTouchTargets.forEach(function (el) {
twkResetMobileTouch(el, true);
});
}
});
}
}
root.querySelectorAll('img').forEach(function (img) {
img.addEventListener('error', function () {
img.style.display = 'none';
if (img.parentElement) {
img.parentElement.style.background =
'linear-gradient(135deg,#f7e7dd 0%,#f3d8c8 50%,#fbf7f4 100%)';
}
});
});
})();
